import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon-order-location.png'


const _withScopeId = n => (_pushScopeId("data-v-571cb466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order-detail" }
const _hoisted_3 = { class: "order-detail-status" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "order-detail-user" }
const _hoisted_6 = { class: "order-detail-user-info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "iphone" }
const _hoisted_9 = { class: "order-detail-module" }
const _hoisted_10 = { class: "order-detail-product" }
const _hoisted_11 = { class: "product-img" }
const _hoisted_12 = { class: "product-info" }
const _hoisted_13 = { class: "item-info" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商品金额", -1))
const _hoisted_15 = { class: "score" }
const _hoisted_16 = {
  key: 0,
  class: "item-info"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "运费", -1))
const _hoisted_18 = { class: "score" }
const _hoisted_19 = { class: "order-cost" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单金额", -1))
const _hoisted_21 = {
  key: 0,
  class: "order-detail-module"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "快递单号", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "可自行复制去第三方平台查询", -1))
const _hoisted_24 = { style: {"width":"40%","text-align":"left"} }
const _hoisted_25 = ["data-clipboard-text"]
const _hoisted_26 = { class: "order-detail-other" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "订单信息", -1))
const _hoisted_28 = { class: "item-info" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单编号", -1))
const _hoisted_30 = ["data-clipboard-text"]
const _hoisted_31 = { class: "item-info" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下单时间", -1))

import { ref, computed, onActivated } from "vue";
import { getOrderDetail } from "@/server/api";
import { OrderDetail } from "@/server/interface";
import { useRouter } from "vue-router";
import Clipboard from "clipboard";
import { showToast } from "vant";

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetailDTC',
  setup(__props) {

const $router = useRouter();
const showStatus = ref<
  Record<string, { title: string; name: string; url: string }>
>({
  TO_BE_SHIPPED: {
    title: "待发货",
    name: "商品正在准备中",
    url: require("../assets/icon-order-send.png"),
  },
  SHIPPED: {
    title: "待收货",
    name: "商品已发货",
    url: require("../assets/icon-order-send.png"),
  },
  FINISHED: {
    title: "已完成",
    name: "您的订单已签收",
    url: require("../assets/icon-order-success.png"),
  },
  CANCEL: {
    title: "已取消",
    name: "积分将退回到原账户",
    url: require("../assets/icon-order-cancel.png"),
  },
});

// 安全获取订单状态显示信息
const currentStatus = computed(() => {
  return (
    showStatus.value[orderDetails.value.orderStatus] || {
      title: "",
      name: "",
      url: "",
    }
  );
});

const orderDetails = ref<OrderDetail>({
  orderId: "",
  createdAt: "",
  orderStatus: "SHIPPED",
  points: 0,
  receiverInfo: {
    recipientName: "",
    recipientPhone: "",
    addressLine1: "",
    province: "",
    city: "",
    district: "",
    country: "",
    zipCode: "",
  },
  items: [],
  deliveryStatuses: {
    isSplit: 0,
    shipments: [],
  },
  expressPoints: 0,
  cdpRedeemId: "",
  omsOrderCode: "",
});

const hrefLink = ref("");

const isFormExchange = ref("");

// 获取订单详情
const queryOrderDetail = async (orderId: string) => {
  try {
    const orderDetail = await getOrderDetail({ orderId });
    console.log("getOrderDetail", orderDetail);
    orderDetails.value = orderDetail?.data;
  } catch (error) {
    console.error("获取订单详情失败", error);
  }
};

onActivated(() => {
  hrefLink.value = window.localStorage.getItem("hrefLink") as string;
  isFormExchange.value = ($router.currentRoute.value.query?.isFormExchange ||
    "") as string;

  const orderId = ($router.currentRoute.value.query?.orderId || "") as string;
  orderId && queryOrderDetail(orderId);
});

// 复制文本到剪贴板
const copyToClipboard = (selector: string) => {
  const clipboard = new Clipboard(selector);
  clipboard.on("success", () => {
    showToast("复制成功");
    clipboard.destroy();
  });
  clipboard.on("error", () => {
    showToast("该浏览器不支持复制");
    clipboard.destroy();
  });
};

const copy = () => copyToClipboard(".tag-read");
const copyNo = () => copyToClipboard(".express-no-read");

const goBack = () => {
  if (isFormExchange.value) {
    $router.go(-5);
  } else {
    $router.go(-2);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createElementVNode("img", {
            src: _unref(currentStatus).url,
            alt: "订单状态"
          }, null, 8, _hoisted_4),
          _createElementVNode("span", null, _toDisplayString(_unref(currentStatus).title), 1)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString(_unref(currentStatus).name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, [
            _hoisted_7,
            _createElementVNode("span", null, "收货人：" + _toDisplayString(orderDetails.value.receiverInfo?.recipientName), 1)
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(orderDetails.value.receiverInfo?.recipientPhone), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString([
              orderDetails.value.receiverInfo?.province,
              orderDetails.value.receiverInfo?.city,
              orderDetails.value.receiverInfo?.district,
              orderDetails.value.receiverInfo?.addressLine1,
            ]
              .filter(Boolean)
              .join(" ")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderDetails.value.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "order-detail-product-group"
          }, [
            _createElementVNode("h1", null, _toDisplayString(`商品信息${orderDetails.value.items.length > 1 ? index + 1 : ""}`), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_van_image, {
                  src: item.image
                }, {
                  loading: _withCtx(() => [
                    _createVNode(_component_van_loading, {
                      type: "spinner",
                      size: "20"
                    })
                  ]),
                  _: 2
                }, 1032, ["src"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", null, _toDisplayString(item.skuName), 1),
                _createElementVNode("p", null, _toDisplayString(item.subTitle), 1),
                _createElementVNode("p", null, [
                  _createElementVNode("span", null, "x" + _toDisplayString(item.quantity), 1)
                ])
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", null, [
            _createElementVNode("em", _hoisted_15, _toDisplayString(orderDetails.value.points - orderDetails.value.expressPoints), 1),
            _createTextVNode("积分")
          ])
        ]),
        (orderDetails.value.expressPoints)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", null, [
                _createElementVNode("em", _hoisted_18, _toDisplayString(orderDetails.value.expressPoints), 1),
                _createTextVNode("积分")
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("span", null, [
            _createElementVNode("em", null, _toDisplayString(orderDetails.value.points), 1),
            _createTextVNode("积分")
          ])
        ])
      ]),
      (orderDetails.value.deliveryStatuses?.shipments?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _hoisted_23,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderDetails.value.deliveryStatuses?.shipments, (shipment, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item-info",
                key: index
              }, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(shipment.transCode), 1),
                _createElementVNode("em", {
                  class: "express-no-read",
                  "data-clipboard-text": shipment.transCode,
                  onClick: copyNo
                }, "复制", 8, _hoisted_25)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(orderDetails.value.orderId), 1),
            _createElementVNode("em", {
              class: "tag-read",
              "data-clipboard-text": orderDetails.value.orderId,
              onClick: copy
            }, "复制", 8, _hoisted_30)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("span", null, _toDisplayString(orderDetails.value.createdAt), 1)
        ])
      ]),
      _createElementVNode("div", { class: "link-to-home" }, [
        _createElementVNode("button", {
          onClick: goBack,
          class: "gohome"
        }, "返回首页")
      ])
    ])
  ]))
}
}

})